module.exports = {"Roles":"Roles","TeamTabRoles":"Team Tab Roles","Users":"Users","UsersTitles":"User Titles","Result":"Result"}


//////////////////
// WEBPACK FOOTER
// ./src/components/_modules/Approvals/Approval-rule/option-type.json
// module id = Ga5e
// module chunks = 12